import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import {DvrService} from '../../../services/api/dvr/dvr.service';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';
import {stopRecord, stopRecordFailure, stopRecordSuccess} from '../actions/stop-record.actions';
import {loadRecords} from '../actions/records.actions';


@Injectable()
export class StopRecordEffects {

  // noinspection JSUnusedGlobalSymbols
  stopRecord$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(stopRecord),
      concatMap((payload: { recordId: UUID }) =>
        this.dvrService.stopRecord(payload.recordId)
          .pipe(
            map((data: DvrRecord) => stopRecordSuccess({data})),
            catchError((error: unknown) => of(stopRecordFailure({error}))))
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  stopRecordSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(stopRecordSuccess),
        tap(() => this.snackBar.open('Recording stopped successfully', 'Success', {duration: 3000})),
        map(() => loadRecords())
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly snackBar: MatSnackBar,
    private readonly dvrService: DvrService
  ) {
  }

}
